/**
 * Created by danielg on 8/31/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    window.App = window.App || {};
    window.lpTag.AMSStatics = window.lpTag.AMSStatics || {};

    var _ = require('underscore');
    var LEConfig = require("assets/config/le-env-conf");
    var webAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');
    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpSecureFormsController = require('web-agent-assets-js/lpSecureFormsController');
    var privilegesController = require('web-agent-assets-js/lpPrivilegesController');
    var MessagingUtils = require('web-agent-utils/MessagingUtils');
    var PredefinedContentMacroUtils = require("web-agent-utils/PredefinedContentMacroUtils");
    var lpUtils = require('assets/js/utils/lpUtils');

    /////////////////////////////////// PRIVATE VARIABLES ///////////////////////////////////
    var amsCommunicationChannel = webAgentStatics.COMMUNICATION_CHANNELS.AMS;
    var appEventsCommunicationChannel = webAgentStatics.COMMUNICATION_CHANNELS.AppEvents;

    var messagesModel;
    var logger;
    var conversationsDictionary;
    var maxQuantity = 1000;
    var pageFocusLevel = _getDefaultFocusStateID();
    var pendingForMarkAsReadConversationId;
    var agentTabVisible;

    var EVENT_TYPES = lpTag.AMSStatics.eventTypes;
    var MESSAGE_STATES = lpTag.AMSStatics.messageState;
    var MESSAGE_STATES_LEVELS = {
        SENT: 0,
        ACCEPT: 1,
        READ: 2,
        VIEWED: 3,
        ERROR: 4,
        NACK: 5
    };

    var USER_PROFILE_ROLES = lpTag.AMSStatics.participant.roles;

    /////////////////////////////////// INITIALIZATION ///////////////////////////////////

    var lpMessagesControllerV2 = BaseController.extend(function lpMessagesController(options) {
        conversationsDictionary = {};
        logger = this.logger || WebAgentLogger.getLogger(this.applicationType);

        _setModel(options.model);
        lpTag.WebAgent.channel.register(amsCommunicationChannel.name, amsCommunicationChannel.events.onEventNotification, this.onEventNotification.bind(this));

    });
    agentLEManager.onLEEvent("focusStatus:change", _changeExternalFocus, this);
    agentLEManager.bindToLEValue('change:LEWebAgent.isVisible', _changeInternalFocus, this);

    /////////////////////////////////// PUBLIC VARIABLES ///////////////////////////////////
    lpMessagesControllerV2.prototype.applicationType = 'MessagesController';
    lpMessagesControllerV2.prototype.MESSAGE_STATES = MESSAGE_STATES;

    /////////////////////////////////// PUBLIC METHODS ///////////////////////////////////

    /**
     * Called when an event is published
     * @param data - The data of the event
     */
    lpMessagesControllerV2.prototype.onEventNotification = function (data) {
        if (data && data.event && data.event.type) {
            _initQueryMessageObject(_getConversationId(data));
            switch (data.event.type) {
                case EVENT_TYPES.CONTENT:
                    _addDataToEvent(data);
                    _handleNewContentMessage.call(this, data);
                    break;
                case EVENT_TYPES.RICH_CONTENT:
                    _addDataToEvent(data);
                    _handleNewStructuredContentMessage.call(this, data);
                    break;
                case EVENT_TYPES.ACCEPT_STATUS:
                    _addDataToEvent(data);
                    _handleNewMessageState.call(this, data);
                    break;
                case EVENT_TYPES.CHAT_STATE:
                    _handleChatState.call(this, data);
                    break;
            }
            _updateConsumerClientProperties(data, true);
        }
    };

    /**
     * Sends a message from the Agent to the consumer over the given conversation id
     * @param messageData - The message data
     * @param serverHandler - if we need to make some preparations before sending the line to UMS, this method will be
     *                        provided with everything it needs to handle sending the line and calling the error/retry callbacks.
     */
    lpMessagesControllerV2.prototype.addLine = function (messageData, serverHandler) {
        var rndId, time, context, metadata, dataToSend;
        dataToSend = messageData;
        messageData.verified = false;
        messageData.conversationId = messageData.chatId;
        messageData.dialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(messageData.chatId);
        messageData.source = 'agent';
        messageData.originatorId = messagesModel.get('agent.messagingUserId');
        time = new Date().getTime();
        rndId = messageData.dialogId + ":LPAgentLine" + time;
        messageData.verificationId = rndId;
        messageData.time = time;

        // todo fail empty messages post macro replacement? ask product! problematic moving this backward in the logic and preventing the send line
        // macro replacements if needed
        if (messageData.text && PredefinedContentMacroUtils.test(messageData.text)) {
            context = lpTag.WebAgent.logicController.getPredefinedContentMacroContext(messageData.chatId);
            messageData.text = PredefinedContentMacroUtils.replace(messageData.text, context);
        }

        if (LEConfig.sendPDCEventForMessaging && !_.isEmpty(messageData.cannedResponse)) {
            metadata = messageData.metadata || [];
            metadata.push({
                type: "PredefinedResponse",
                id: messageData.cannedResponse.cannedAnswerId || -1,
                categoryId: messageData.cannedResponse.cannedTreeId,
                edited: messageData.cannedResponse.edited
            });
            messageData.metadata = metadata;
        }

        messageData.success = function (data) {
            messageData.verified = true;
            messageData.sequenceId = _getSequenceId(data);
            messageData.id = _getDialogId(messageData) + ':' + _getSequenceId(data);
            conversationsDictionary[messageData.conversationId].messages.push(messageData);
            if(_isImageMsg(messageData)){
                messageData.event.message.id = messageData.id;
            }

            messagesModel.modify('chats.' + messageData.conversationId + '.chatInfo.events.event', [messageData]);
            messagesModel.modify('chats.' + messageData.conversationId + '.newChatLine.lines', [messageData]);
            messagesModel.modify('chats.' + messageData.conversationId + '.chatInfo.linesState', conversationsDictionary[messageData.conversationId].chatLinesMap);

            if (messageData.doneCallback && typeof messageData.doneCallback === 'function') {
                messageData.doneCallback();
            }
        };

        messageData.error = function (data) {
            messageData.failed = true;
            messageData.errorData = data.error;
            messagesModel.modify('chats.' + messageData.conversationId + '.chatInfo.events.event', [messageData]);
            messagesModel.modify('chats.' + messageData.conversationId + '.newChatLine.lines', [messageData]);
        };

        messageData.retry = function() {
            messageData.failed = false;
            messageData.errorData = null;
            messagesModel.modify('chats.' + messageData.conversationId + '.chatInfo.events.event', [messageData]);
            messagesModel.modify('chats.' + messageData.conversationId + '.newChatLine.lines', [messageData]);
        };

        if (messageData.contentType === lpAMSController.CONTENT_TYPES.HOSTED_FILE) {
            messageData.fileType = _getFileType(messageData.event.message);
            dataToSend = lpUtils.cloneObject(messageData);
            dataToSend.text = dataToSend.event.message;
        }
        messagesModel.modify('chats.' + messageData.chatId + '.chatInfo.events.event', [messageData]);
        messagesModel.modify('chats.' + messageData.chatId + '.newChatLine.lines', [messageData]);
        var callback;
        if(messageData.type === 'richContent') {
            callback = lpTag.WebAgent.amsConnectionController.amsClient.sendStructuredContentMessage.bind(lpTag.WebAgent.amsConnectionController.amsClient, dataToSend);
        } else {
            callback = lpTag.WebAgent.amsConnectionController.amsClient.sendMessage.bind(lpTag.WebAgent.amsConnectionController.amsClient, dataToSend);
        }
        if (serverHandler) {
            var callbackWrapper = function(relativePath) {
                if (relativePath && dataToSend.contentType === lpAMSController.CONTENT_TYPES.HOSTED_FILE) {
                    dataToSend.event.message.relativePath = relativePath;
                    dataToSend.text = dataToSend.event.message;
                }
                callback();
            };
            serverHandler({
                callback: callbackWrapper,
                error: messageData.error,
                retry: messageData.retry,
                id: messageData.verificationId
            });
        } else {
            callback();
        }
    };

    // TODO: optimize it
    lpMessagesControllerV2.prototype.queryMessages = function (conversationId) {
        if (!conversationId) {
            return;
        }

        _initQueryMessageObject(conversationId, true);
        var context = { convId: conversationId, context: this };
        var dialogs = lpTag.WebAgent.logicController.getAllDialogsOfConversation(conversationId);
        dialogs = getPermittedDialogs(dialogs);

        var dialogsToWaitFor = {};
        _.each(Object.keys(dialogs), function (dialogId) {
            dialogsToWaitFor[dialogId] = 1; // indicates the current index of the dialog request
        });

        _.each(Object.keys(dialogs), function (dialogId) {
            _getQueryMessages(conversationId, dialogId, maxQuantity);
        });

        function getPermittedDialogs(dialogs) {
            var permittedDialogs = {};
            _.each(dialogs, function (dialogVal, dialogKey) {
                switch (dialogVal.dialogType) {
                    case lpAMSController.DIALOG_TYPES.MAIN:
                        permittedDialogs[dialogKey] = dialogVal;
                        break;
                    case lpAMSController.DIALOG_TYPES.POST_SURVEY:
                        if (privilegesController.hasViewMessagingSurveysPrivilege()) {
                            permittedDialogs[dialogKey] = dialogVal;
                        }
                        break;
                    default:
                        break;
                }
            });
            return permittedDialogs;
        }

        function _getQueryMessages(conversationId, dialogId, lastSequence) {
            var obj = {
                conversationId: conversationId,
                dialogId: dialogId,
                maxQuantity: maxQuantity,
                olderThan: lastSequence - 1,
                newerThan: Math.max(lastSequence - maxQuantity, 0),
                context: context,
                success: _onQueryDialogResponse.bind(context, dialogId),
                numCallbacks: 2
            };
            lpTag.WebAgent.amsConnectionController.amsClient.newQueryMessages(obj);
        }

        function _onQueryDialogResponse(dialogId, data) {
            var conversationId = this.convId;
            conversationsDictionary[conversationId].messages = conversationsDictionary[conversationId].messages.concat(data);

            if (data.length === maxQuantity) { // means there are probably more messages of the dialog
                dialogsToWaitFor[dialogId]++;
                var newLastSequence = dialogsToWaitFor[dialogId] * maxQuantity;
                _getQueryMessages(conversationId, dialogId, newLastSequence);
            } else {
                delete dialogsToWaitFor[dialogId];
                if (_.isEmpty(dialogsToWaitFor)) {
                    var allDialogsMessages = _.sortBy(conversationsDictionary[conversationId].messages, 'serverTimestamp'); // arrange messages by time
                    var dialogs = lpTag.WebAgent.logicController.getAllDialogsOfConversation(conversationId);
                    lpTag.WebAgent.logicController.addIndicationToStartAndEndDialogLines(allDialogsMessages, dialogs);
                    _onQueryResponse.call(this, allDialogsMessages);
                }
            }
        }
    };

    lpMessagesControllerV2.prototype.setMsgStatus = function (msgObj) {
        _setMsgStatus(msgObj);
    };


    /////////////////////////////////// PRIVATE METHODS ///////////////////////////////////

    function _handleNewStructuredContentMessage(data) {
        data.contentType = lpAMSController.CONTENT_TYPES.RICH_CONTENT;
        _handleNewContentMessage.call(this, data);
    }

    function _handleNewContentMessage(data) {
        var conversationId = _getConversationId(data);
        var dialogId = _getDialogId(data);
        var isInMyEngagements = lpTag.WebAgent.logicController.isInMyEngagements(conversationId);
        var isAcceptedEngagementByChatId = lpTag.WebAgent.logicController.isAcceptedEngagementByChatId(conversationId);
        var hasEngagement = messagesModel.get(lpTag.WebAgent.logicController.getParticipantPath(data.originatorId));
        var isOpenConversation = lpTag.WebAgent.logicController.getConversationStateByChatId(conversationId) === lpAMSController.CONVERSATION_STATES.OPEN;
        var isMyMessage = _isOriginatorLoggedInAgent(data);
        var isSpectatedEngagement = _isLoggedInAgentSpectateParticipant(conversationId, dialogId);

        _addContentDataToEvent(data);
        if (isMyMessage) {
            data.status = MESSAGE_STATES.SENT;
            updateRowParticipantState(data, data.status, data.originatorId);
        }
        _updateContentMessageToInternalMemory(data);
        _setNewMessageToTheModel(data);

        // If the consumer sent new unread chat lines and we don't have an open orb we want to open an engagement orb

        if (!isMyMessage && (!hasEngagement || isOpenConversation) && !isInMyEngagements &&
            (isAcceptedEngagementByChatId || isSpectatedEngagement)
        ) {
            lpTag.WebAgent.amsController.createMyEngagementForConversation(conversationId, true);
        }
    }

    function _isLoggedInAgentSpectateParticipant(conversationId, dialogId) {
        var isLoggedInAgentPeekerParticipant = lpTag.WebAgent.logicController.isLoggedInAgentPeekerParticipant(conversationId, dialogId);
        var role = lpTag.WebAgent.logicController.getLoggedInAgentRoleInConversationDialog(conversationId, dialogId);
        return (role === USER_PROFILE_ROLES.MANAGER || role === USER_PROFILE_ROLES.READER) && !isLoggedInAgentPeekerParticipant;
    }

    function _handleNewMessageState(data) {
        _updateMessageStateToInternalMemory(data);
        _setNewMessageToTheModel(data);
    }

    function _handleChatState(data) {
        var conversationId, userId, state;

        if (data) {
            conversationId = _getConversationId(data);
            userId = data.originatorId;
            state = data.event && data.event.chatState;
        }
        if (conversationId && userId && state) {
            if (_isOriginatorConsumer(data)) {
                switch (state.toLowerCase()) {
                    case lpTag.AMSStatics.chatStates.COMPOSING:
                        messagesModel.set('chats.' + conversationId + '.visitorInfo.visitorTyping', true);
                        break;
                    default:
                        messagesModel.set('chats.' + conversationId + '.visitorInfo.visitorTyping', false);
                        break;
                }
            }
        }
    }

    function _addDataToEvent(messageData) {
        messageData.conversationId = _getConversationId(messageData);
        messageData.sequenceId = _getSequenceId(messageData);
        messageData.id = messageData.dialogId + ':' + messageData.sequenceId;
        messageData.time = messageData.serverTimestamp;
    }

    function _addContentDataToEvent(messageData) {
        if (messageData) {
            _addMessageContentToEvent(messageData);
            _addQuickRepliesToEvent(messageData);
            _addOriginToEvent(messageData);
        }
    }

    function _addMessageContentToEvent(messageData) {
        _handleContentType(messageData);
        messageData.source = _getMessageOriginType(messageData);

    }

    function _addQuickRepliesToEvent(messageData) {
        if (messageData.event && messageData.event.quickReplies) {
            messageData.quickReplies = messageData.event.quickReplies;
        }
    }

    function _addOriginToEvent(messageData) {
        if (_isOriginatorLoggedInAgent(messageData)) {
            messageData.by = messagesModel.get('agent.agentName') || agentLEManager.translateLE('LEWebAgent.agentDefaultName');
        } else {
            var originator = messagesModel.get('userProfiles.' + messageData.originatorId);
            if (originator && originator.fullName) {
                messageData.by = originator.fullName;
                if (originator.role !== USER_PROFILE_ROLES.CONSUMER) {
                    messageData.agentDeleted = originator.isDeleted;
                }
            } else {
                messageData.by = _getMessageOriginType(messageData);
            }
        }
    }

    function _setMsgStatus(msgObj) {
        if (!conversationsDictionary[msgObj.conversationId] || conversationsDictionary[msgObj.conversationId].markMsgAsReadInProcces) {
            return;
        }
        var convState = messagesModel.get('chats.' + msgObj.conversationId + '.chatInfo.messagingState');
        var dialog = lpTag.WebAgent.logicController.getDialogOfConversation(msgObj.conversationId, msgObj.dialogId);
        if ((dialog && dialog.state === lpAMSController.CONVERSATION_STATES.CLOSE) ||
            convState === lpAMSController.CONVERSATION_STATES.CLOSE) {
            return;
        }
        if (msgObj.state.toUpperCase() === MESSAGE_STATES.READ.toUpperCase() && (!msgObj.sequenceList || !msgObj.sequenceList.length)) {
            _markMsgAsRead(msgObj.conversationId);
        } else {
            lpTag.WebAgent.amsConnectionController.amsClient.markMessagesState(msgObj);
        }

    }

    function _markMsgAsRead(convId) {
        if (!_checkIfVisible()) { // Only mark as read if the window is focused, agent's tab is visible and the conversation is selected
            pendingForMarkAsReadConversationId = convId;
            return;
        }

        var dialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(convId);
        var unReadLines = _getUnreadChatLines(convId, dialogId);

        if (!unReadLines || !unReadLines.length) {
            return;
        }

        var conv = conversationsDictionary[convId];
        var convChatLinesMap = conversationsDictionary[convId].chatLinesMap;

        var msgObj = {
            conversationId: convId,
            dialogId: dialogId,
            state: MESSAGE_STATES.READ,
            sequenceList: unReadLines
        };
        conv.markMsgAsReadInProcces = true;


        msgObj.success = function () {
            logger.info('mark messages state succeed', '_markMsgAsRead');
            logger.info("", '_markMsgAsRead', arguments);
            for (var i = 0; i < unReadLines.length; i++) {
                var line = convChatLinesMap[dialogId + ':' +unReadLines[i]];
                if (!line) {
                    line = {status: MESSAGE_STATES.READ};
                } else {
                    line = MESSAGE_STATES.READ;
                }
            }
            for (var y = 0; y < conv.chatLines.length; y++) {
                var chatLine = conv.chatLines[y];
                if (!_isOriginatorLoggedInAgent(chatLine)) {
                    chatLine.status = MESSAGE_STATES.READ;
                }
            }
            conv.markMsgAsReadInProcces = false;
        };

        msgObj.error = function () {
            logger.error('mark messages state failed', '_markMsgAsRead');
            logger.error("", '_markMsgAsRead', arguments);
            conv.markMsgAsReadInProcces = false;
        };

        lpTag.WebAgent.amsConnectionController.amsClient.markMessagesState(msgObj);
    }

    function _getMessageOriginType(messageData) {
        var originType, userProfile;

        if(messageData.originatorMetadata && messageData.originatorMetadata.role) {
            switch (messageData.originatorMetadata.role) {
                case USER_PROFILE_ROLES.CONTROLLER:
                    originType = 'system';
                    break;
                case USER_PROFILE_ROLES.CONSUMER:
                    originType = 'visitor';
                    break;
                default:
                    originType = 'agent';
                    break;
            }
        } else { // The else is temproraly and need to be removed when messageData.originatorMetadata.role is stable on GA
            if(_isOriginatorConsumer(messageData)) {
                originType = 'visitor';
            } else{
                userProfile = lpTag.WebAgent.AppMediator.getModelParam('userProfiles.' + messageData.originatorId);
                if(userProfile && userProfile.role === USER_PROFILE_ROLES.CONTROLLER) {
                    originType = 'system';
                } else {
                    originType = 'agent';
                }
            }
        }

        return originType;
    }

    function _handleContentType(msgObj) {
        if(!msgObj.contentType) {
            msgObj.contentType = msgObj.event && msgObj.event.contentType;
        }
        switch (msgObj.contentType) {
            case lpAMSController.CONTENT_TYPES.EXTERNAL_FILE:
            case lpAMSController.CONTENT_TYPES.HOSTED_FILE:
                msgObj.externalFileLink = msgObj.event.message.externalFileLink;
                msgObj.fileType = _getFileType(msgObj.event.message);
                msgObj.caption = msgObj.event.message.caption || '';
                msgObj.text = msgObj.caption;
                if (msgObj.fileType === lpAMSController.FILE_TYPES.AUDIO) {
                    msgObj.isAudio = true;
                } else {
                    msgObj.isImage = true;
                }
                break;
            case lpAMSController.CONTENT_TYPES.RICH_CONTENT:
                msgObj.json = msgObj.event && msgObj.event.content;
                msgObj.isRichContent = true;
                break;
            default:
                msgObj.text = msgObj.event && msgObj.event.message || "";
                break;
        }
    }

    function _getFileType(msgObj) {
        var fileType = msgObj.fileType && msgObj.fileType.toUpperCase();
        return MessagingUtils.getParentFileType(fileType);
    }

    function _isOriginatorConsumer(messageData) {
        var convId = _getConversationId(messageData);
        var consumerId = messagesModel.get('chats.' + convId + '.visitorInfo.visitorId') || conversationsDictionary[convId].consumerId;
        return messageData.originatorId === consumerId;
    }

    /**
     * checks if the message originator is currently participating in the active dialog.
     * the originator will not be a participant if they left the conversation or returned it to the queue,
     * but message events will still be published for that participant.
     * @param messageData
     * @returns {boolean}
     * @private
     */
    function _isOriginatorParticipatingInDialog(messageData) {
        if (!messageData) {
            return false;
        }
        var conversationId = _getConversationId(messageData);
        var dialogId = _getDialogId(messageData);
        var messageOriginatorId = messageData.originatorId;
        var originatorIdWithoutAccount = _.last(messageOriginatorId.split('.')); // remove Account Id if it included.
        var chatConsumerId = messagesModel.get('chats.' + conversationId + '.visitorInfo.visitorId');
        var role = messagesModel.get('chats.' + conversationId + '.chatInfo.dialogs.' + dialogId + '.participantsDetails.' + originatorIdWithoutAccount + '.role');
        return role && (role === USER_PROFILE_ROLES.ASSIGNED_AGENT || role === USER_PROFILE_ROLES.MANAGER) || messageOriginatorId === chatConsumerId;
    }

    function _isOriginatorLoggedInAgent(messageData) {
        var myId = messagesModel.get(lpAMSController.MODEL_PATHS.userId);
        if (myId && messageData && messageData.originatorId) {
            return messageData.originatorId === myId;
        }
        return false;
    }

    /**
     * Called when a queryMessages get response. The first response is a string "success". The second response is
     * an array of the messages.
     */
    function _onQueryResponse(data) {
        var conversationId = this.convId;
        _resetQueryMessageObject(conversationId);
        _resolveProfiles(data, function () {
            _onQueryArrayResponse(data, conversationId);
        });
    }

    function _resolveProfiles(messages, onResolved) {
        var participantIds = _.map(messages, 'originatorId');
        var uniqueParticipantIds = _.unique(participantIds);
        logger.info('participant ids extracted from query message response: ' + uniqueParticipantIds, '_onQueryResponse');
        lpTag.WebAgent.amsUserProfilesController.getUserProfiles({
            users: uniqueParticipantIds,
            done: onResolved
        });
    }

    function _initQueryMessageObject(conversationId, force) {
        if (conversationId) {
            var isNew = !conversationsDictionary[conversationId];
            if (isNew) {
                conversationsDictionary[conversationId] = {};
                conversationsDictionary[conversationId].chatLinesMap = {};
            }
            if (isNew || force) {
                _resetQueryMessageObject(conversationId);
            }
        }
    }

    function _resetQueryMessageObject(conversationId) {
        if (conversationId) {
            conversationsDictionary[conversationId].messages = [];
            conversationsDictionary[conversationId].chatLines = [];
            conversationsDictionary[conversationId].images = [];
            conversationsDictionary[conversationId].audio = [];
        }
    }

    function _onQueryArrayResponse(data, conversationId) {
        var featuresAndIntegration;
        if (data && data.constructor === Array) {
            if (data.length > 0) {
                for (var index = 0; index < data.length; index++) {
                    var message = data[index];
                    message.conversationId = conversationId;
                    var tempFeatureAndIntegration = _handleQueryMessage(message);
                    if (tempFeatureAndIntegration) {
                      featuresAndIntegration = tempFeatureAndIntegration;
                    }
                }
                if (featuresAndIntegration && conversationId) {
                  messagesModel.set('chats.' + conversationId + '.chatInfo.features', featuresAndIntegration.features);
                  messagesModel.set('chats.' + conversationId + '.chatInfo.integration', featuresAndIntegration.integration);
                }
            }
            if (conversationId) {
                _updateConversationToTheModel(conversationId);
                _sendAcceptMsgIfNeeded(conversationId);
                lpTag.WebAgent.channel.publish(appEventsCommunicationChannel.name, appEventsCommunicationChannel.events.queryMessagesCompleted, conversationId );
            }
        }
    }

    function _updateConversationToTheModel(convId) {
        //this function invoke when the first bulk of msg arrived
        if (conversationsDictionary[convId].chatLines.length) {
            messagesModel.set('chats.' + convId + '.chatInfo.events.event', conversationsDictionary[convId].chatLines);
            messagesModel.set('images.' + convId, conversationsDictionary[convId].images);
            messagesModel.set('audio.' + convId, conversationsDictionary[convId].audio);
        }
        messagesModel.set('chats.' + convId + '.oldChatLine.lines', conversationsDictionary[convId].chatLines);
        messagesModel.modify('chats.' + convId + '.chatInfo.linesState', conversationsDictionary[convId].chatLinesMap);
    }

    function _isImageMsg(chatLine){
        return chatLine && chatLine.event && chatLine.contentType === lpAMSController.CONTENT_TYPES.HOSTED_FILE && chatLine.fileType !== lpAMSController.FILE_TYPES.AUDIO;
    }

    function _isAudioMsg(chatLine){
        return chatLine && chatLine.event && chatLine.contentType === lpAMSController.CONTENT_TYPES.HOSTED_FILE && chatLine.fileType === lpAMSController.FILE_TYPES.AUDIO;
    }

    function _handleQueryMessage(message) {
        if (message && message.event && message.event.type) {
            switch (message.event.type) {
                case EVENT_TYPES.CONTENT:
                    _addDataToEvent(message);
                    _handleQueryContentMessage(message);
                    break;
                case EVENT_TYPES.RICH_CONTENT:
                    _addDataToEvent(message);
                    _handleQueryStructuredContentMessage(message);
                    break;
                case EVENT_TYPES.ACCEPT_STATUS:
                    _addDataToEvent(message);
                    _handleQueryMessageState(message);
                    break;
                case EVENT_TYPES.CHAT_STATE:
                    _handleChatState(message);
                    break;
            }
            return _updateConsumerClientProperties(message);
        }
    }

    function _handleQueryStructuredContentMessage(data) {
        data.contentType = lpAMSController.CONTENT_TYPES.RICH_CONTENT;
        _handleQueryContentMessage.call(this, data);
    }

    function _handleQueryContentMessage(data) {
        _addContentDataToEvent(data);
        if (_isOriginatorLoggedInAgent(data)) {
            data.status = MESSAGE_STATES.SENT;
        }
        _updateContentMessageToInternalMemory(data);
    }

    function _handleQueryMessageState(data) {
        _updateMessageStateToInternalMemory(data);
    }


    /**
     * Sets the model
     * @param model - the model
     * @private
     */
    function _setModel(model) {
        if (model) {
            messagesModel = model;
        }
    }

    function _isChatLine(msg) {
        return msg.type === 'line' || msg.type === 'leCollaboration' || msg.type === 'richContent';
    }

    function _updateContentMessageToInternalMemory(messageData) {
        _updateMessageToInternalMemory(messageData, _updateChatLinesObjForContent);
    }

    function _updateMessageStateToInternalMemory(messageData) {
        _updateMessageToInternalMemory(messageData, _updateChatLinesObjForState);
    }

    function _updateMessageToInternalMemory(messageData, _handleMsgType) {
        var conversationId = _getConversationId(messageData);
        if (conversationId) {
            _handleMsgType(messageData);
        }
    }

    function _setNewMessageToTheModel(messageData) {
        var conversationId = _getConversationId(messageData);
        messagesModel.modify('chats.' + conversationId + '.chatInfo.linesState', conversationsDictionary[conversationId].chatLinesMap);
        if (_isChatLine(messageData)) {
            messagesModel.modify('chats.' + conversationId + '.chatInfo.events.event', [messageData]);
            messagesModel.modify('chats.' + conversationId + '.newChatLine.lines', [messageData]);
            _setMessageMetadataForWidgetSDK(messageData, conversationId);
            if(_isImageMsg(messageData)){
                messagesModel.modify('images.' + conversationId , [messageData]);
            } else if(_isAudioMsg(messageData)) {
                messagesModel.modify('audio.' + conversationId , [messageData]);
            }
        }
        _sendAcceptMsgIfNeeded(conversationId);
    }

    function _getUnreadChatLines(convId, activeDialogId) {
        if (!convId) {
            return;
        }

        var chatLinesMap = conversationsDictionary[convId].chatLinesMap;
        var chatLinesArray = conversationsDictionary[convId].chatLines;
        var loggedInAgent = messagesModel.get('agent.messagingUserId');
        var returnArr = [];

        if (!chatLinesMap) {
            return;
        }
        for (var i = 0; i < chatLinesArray.length; i++) {
            var chatLine = chatLinesArray[i];
            if ((chatLine.status !== MESSAGE_STATES.READ || !_readByLoggedInAgent(chatLine)) && _isOriginatorParticipatingInDialog(chatLine) && chatLine.dialogId === activeDialogId) {
                if (loggedInAgent !== chatLine.originatorId) {
                    returnArr.push(chatLine.sequenceId);
                }
                updateRowParticipantState(chatLine, MESSAGE_STATES.READ, loggedInAgent);
            }
        }
        return returnArr;
    }

    function updateRowParticipantState(chatLine, state, participantId) {
        if (!chatLine.lineParticipantState) {
            chatLine.lineParticipantState = {};
        }

        if (!chatLine.lineParticipantState[participantId] || isNewStateUpdated(chatLine.lineParticipantState[participantId], state) ) {
            chatLine.lineParticipantState[participantId] = state;
        }
    }

    function updateRowParticipantActions(chatLine, actionMessageSequenceRef, participantId) {
        if (!chatLine.lineParticipantAction) {
            chatLine.lineParticipantAction = {};
        }
        if (!chatLine.lineParticipantAction[participantId]) {
            chatLine.lineParticipantAction[participantId] = {};
        }
        chatLine.lineParticipantAction[participantId].actionMessageSequenceRef = actionMessageSequenceRef;
    }

    function isNewStateUpdated(oldState, newState) {
        return MESSAGE_STATES_LEVELS[oldState] < MESSAGE_STATES_LEVELS[newState];
    }

    function _readByLoggedInAgent(chatLine) {
        var loggedInAgentId = messagesModel.get('agent.messagingUserId');
        var lineKey = chatLine.dialogId + ':' + chatLine.sequenceId;
        var lineParticipantState = conversationsDictionary[chatLine.conversationId].chatLinesMap[lineKey].lineParticipantState;
        if (lineParticipantState) {
            return lineParticipantState[loggedInAgentId] === MESSAGE_STATES.READ;
        }
        return false;
    }

    function _updateChatLinesObjForContent(messageData) {
        if (!messageData) {
            return;
        }

        var conversationId = _getConversationId(messageData);
        var chatLinesArray = conversationsDictionary[conversationId].chatLines;
        var messagesArray  = conversationsDictionary[conversationId].messages;
        var imagesArray  = conversationsDictionary[conversationId].images;
        var audioArray  = conversationsDictionary[conversationId].audio;
        if(messageData.contentType === lpAMSController.CONTENT_TYPES.RICH_CONTENT) {
            messageData.type = 'richContent';
        } else {
            messageData.type = 'line';
        }
        if(messageData.contentType === "forms/secure-invitation") {
            _buildInvitationSecureFormEvent(messageData);
            _buildInvitationSecureFormLine(messageData);
        }
        if(messageData.contentType === "forms/secure-submission") {
            _buildSubmitSecureFormEvent(messageData);
            _buildSubmitSecureFormLine(messageData);
        }
        chatLinesArray.push(messageData);
        _updateChatLinesMap(messageData);
        messagesArray.push(messageData);

        if(_isImageMsg(messageData)){
            imagesArray.push(messageData);
        }

        if(_isAudioMsg(messageData)){
            audioArray.push(messageData);
        }

    }

    function _buildInvitationSecureFormEvent(messageData) {
        var data = {
            events: [
                {
                    subType: lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM,
                    command: lpSecureFormsController.EVENT_TYPES.SEND,
                    args: {
                        secureFormId: messageData.event.message.formId,
                        secureFormName: messageData.event.message.title,
                        uniqueId: messageData.event.message.invitationId,
                        repId: getRepId(),
                        chatId: messageData.conversationId
                    },
                    sequenceId: messageData.sequenceId
                }
            ],
            chatId: messageData.dialogId
        };

        function getRepId() {
            var originatorIdSections = messageData.originatorId.split('.');
            if(originatorIdSections.length === 2) {
                return originatorIdSections[1]; //messageData.originatorId is of the form siteId.repId
            }
        }

        lpTag.WebAgent.secureFormsController.onCollaborationEventHandler(data);
    }

    function _buildInvitationSecureFormLine(messageData) {
        messageData.type = lpSecureFormsController.COLLABORATION_EVENT_NAME;
        messageData.subType = lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM;
        messageData.command = lpSecureFormsController.EVENT_TYPES.SEND;
        messageData.args = {
            secureFormId: messageData.event.message.formId,
            uniqueId: messageData.event.message.invitationId,
            secureFormName: messageData.event.message.title
        };
        messageData.text = agentLEManager.translateLE({key: 'LEWebAgent.' + 'secure_form_send_event_text', args: [{
            isTranslate: false,
            key: messageData.by
        },{
            isTranslate: false,
            key: messageData.args.secureFormName
        }]});
    }

    function _buildSubmitSecureFormEvent(messageData) {
        var data = {
            events: [
                {
                    subType: lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM,
                    command: lpSecureFormsController.EVENT_TYPES.SUBMIT,
                    sequenceId: messageData.sequenceId,
                    args: {
                        uniqueId: messageData.event.message.invitationId,
                        formUuid: messageData.event.message.submissionId
                    }
                }
            ]
        };
        lpTag.WebAgent.secureFormsController.onCollaborationEventHandler(data);
    }

    function _buildSubmitSecureFormLine(messageData) {
        messageData.type = lpSecureFormsController.COLLABORATION_EVENT_NAME;
        messageData.subType = lpSecureFormsController.COLLABORATION_TYPES.SECURE_FORM;
        messageData.command = lpSecureFormsController.EVENT_TYPES.SUBMIT;
        messageData.args = {
            secureFormName: _getSecureFormName(messageData),
            uniqueId: messageData.event.message.invitationId,
            formUuid: messageData.event.message.submissionId
        };
        messageData.text = agentLEManager.translateLE({key: 'LEWebAgent.' + 'secure_form_submit_event_text', args: [{
            isTranslate: false,
            key: messageData.args.secureFormName
        }]});
    }

    function _getSecureFormName(messageData) {
        var currentSecureForm = lpTag.WebAgent.secureFormsController.getSecureFormData(messageData.event.message.invitationId);
        if(currentSecureForm) {
            return currentSecureForm.secureFormName;
        }
    }

    function _updateChatLinesMap(messageData) { // chatLinesMap is of the type: 'dialogId:chatLineId'
        if (!messageData) {
            return;
        }
        var conversationId = _getConversationId(messageData);
        var conv = conversationsDictionary[conversationId];
        var seqId = _getSequenceId(messageData);
        var dialogId = _getDialogId(messageData);
        var lineKey = dialogId + ':' + seqId;

        if (conv.chatLinesMap && !conv.chatLinesMap[lineKey]) {
            // new msg will be added to chatLinesMap object
            conv.chatLinesMap[lineKey] = messageData;

        } else if (conv.chatLinesMap[lineKey].status) {
            var tempStatus = _getUnifiedMessageState(conv.chatLinesMap[lineKey].status);
            conv.chatLinesMap[lineKey] = messageData;
            conv.chatLinesMap[lineKey].status = tempStatus;
        }
        if (messageData.status && !conv.chatLinesMap[lineKey].status) {
            conv.chatLinesMap[lineKey].status = _getUnifiedMessageState(messageData.status);
        }
        updateRowParticipantState(conv.chatLinesMap[lineKey], _getUnifiedMessageState(messageData.status), messageData.originatorId);
    }

    function _updateChatLinesObjForState(messageData) {
        if (_isOriginatorParticipatingInDialog(messageData)) {
            var conv = conversationsDictionary[_getConversationId(messageData)];
            var seqId = _getSequenceId(messageData);
            var dialogId = _getDialogId(messageData);
            var sequenceList = messageData.event && messageData.event.sequenceList;
            if (sequenceList && sequenceList.constructor === Array) {
                for (var i = 0; i < sequenceList.length; i++) {
                    var lineKey = dialogId + ':' + sequenceList[i];
                    if (!conv.chatLinesMap[lineKey]) {
                        conv.chatLinesMap[lineKey] = {};
                    }
                    var status = messageData.event && _getUnifiedMessageState(messageData.event.status);
                    if (lpTag.AMSStatics.messageState.ACTION === status) {
                        updateRowParticipantActions(conv.chatLinesMap[lineKey], seqId, messageData.originatorId);
                    }
                    else {
                        var oldSeq = conv.chatLinesMap[lineKey].statusSequence;
                        var oldStatus = _getUnifiedMessageState(conv.chatLinesMap[lineKey].status);
                        if (status && (!oldStatus || isNewStateUpdated(oldStatus, status)) && (!oldSeq || seqId > oldSeq)) {
                            conv.chatLinesMap[lineKey].status = status;
                            conv.chatLinesMap[lineKey].statusSequence = seqId;
                        }
                        updateRowParticipantState(conv.chatLinesMap[lineKey], status, messageData.originatorId);
                    }
                }
            }
        }
    }

    function _getUnifiedMessageState(state) {
        if (typeof state === 'string') {
            return state.toUpperCase();
        }
    }

    function _sendAcceptMsgIfNeeded(convId) {
        var chatLinesArray = conversationsDictionary[convId].chatLines;
        var notAcceptedMsgSend = [];
        var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(convId);
        var role = lpTag.WebAgent.logicController.getLoggedInAgentRoleInConversationDialog(convId, activeDialogId);
        var canUpdateStateMsg = (role === USER_PROFILE_ROLES.MANAGER || role === USER_PROFILE_ROLES.ASSIGNED_AGENT);

        for (var i = 0; i < chatLinesArray.length; i++) {
            var chatLine = chatLinesArray[i];
            if (chatLine.source === 'visitor' && chatLine.dialogId === activeDialogId && canUpdateStateMsg) {
                if (!chatLine.status) {
                    notAcceptedMsgSend.push(chatLine.sequenceId);
                    chatLine.status = MESSAGE_STATES.ACCEPT;
                    updateRowParticipantState(chatLine, chatLine.status, chatLine.originatorId);
                } else if (chatLine.status !== MESSAGE_STATES.ACCEPT && chatLine.status !== MESSAGE_STATES.READ && chatLine.status !== MESSAGE_STATES.VIEWED) {
                    notAcceptedMsgSend.push(chatLine.sequenceId);
                }
            }
        }
        if (notAcceptedMsgSend.length) {
            _setMsgStatus({
                dialogId: activeDialogId,
                conversationId: convId,
                state: MESSAGE_STATES.ACCEPT,
                sequenceList: notAcceptedMsgSend
            });
        }

    }

    function _updateConsumerClientProperties(data, shouldUpdateModel) {
        if (!data || !data.conversationId || !data.originatorMetadata || !data.originatorMetadata.role || data.originatorMetadata.role !== USER_PROFILE_ROLES.CONSUMER) {
            return;
        }
        var conversationId = data.conversationId;
        var clientProperties = data.originatorClientProperties || data.originatorMetadata.clientProperties;
        if (!clientProperties) {
            return;
        }
        var featuresAndIntegration = MessagingUtils.getFeaturesAndIntegrationFromContext({clientProperties: clientProperties});
        if (shouldUpdateModel && featuresAndIntegration && conversationId) {
            messagesModel.set('chats.' + conversationId + '.chatInfo.features', featuresAndIntegration.features);
            messagesModel.set('chats.' + conversationId + '.chatInfo.integration', featuresAndIntegration.integration);
        }
        return featuresAndIntegration;
    }

    function _getConversationId(messageData) {
        return messageData && messageData.conversationId || _getDialogId(messageData); // if no conversationId take from dialogId for backward compatibility
    }

    function _getDialogId(messageData) {
        return messageData && messageData.dialogId;
    }

    function _getSequenceId(messageData) {
        return messageData && messageData.sequence;
    }

    function _getDefaultFocusStateID() {
        var constLE = agentLEManager.getLEConst();
        return (constLE && constLE.FOCUS_STATUS && constLE.FOCUS_STATUS.VISIBLE_FOCUSED) || 2;
    }

    function _changeExternalFocus(data) {
        if (typeof data !== 'undefined') {
            pageFocusLevel = data;
            if (pendingForMarkAsReadConversationId && _checkIfVisible()) {
                _markMsgAsRead(pendingForMarkAsReadConversationId);
                pendingForMarkAsReadConversationId = null;
            }
        }
    }

    function _changeInternalFocus(model, data) {
        if (data) {
            agentTabVisible = true;
            if (pendingForMarkAsReadConversationId && _checkIfVisible()) {
                _markMsgAsRead(pendingForMarkAsReadConversationId);
                pendingForMarkAsReadConversationId = null;
            }
        } else {
            agentTabVisible = false;
        }
    }

    function _checkIfVisible() {
        if (typeof agentTabVisible === 'undefined') {
            agentTabVisible = agentLEManager.getLEAttributeValue("LEWebAgent", "isVisible");
        }
        return agentTabVisible && pageFocusLevel === _getDefaultFocusStateID();
    }

    /**
     * _setMessageMetadataForWidgetSDK : Looks for MetaData property in the message and if found,
     * checks for the type of response came
     * if it is of type Authentication and Encryption is True, Set the Token for the view
     * Similarly check for Apple Pay Response as well.
     * Can be easily extended for any other metadata information.
     */
    function _setMessageMetadataForWidgetSDK (messageData, conversationId) {
        if (conversationId && messageData && messageData.metadata && messageData.metadata.length !== 0) {
                var visitorId = messagesModel.get('chats.' + conversationId + ".visitorInfo.visitorId");
                var metadata = messageData.metadata;
                for (var key in metadata) {
                    if (metadata[key] && metadata[key].type) {
                        switch (metadata[key].type) {
                            case "ConnectorAuthenticationResponse" :
                                if (metadata[key].encrypted) {
                                    messagesModel.modify("participants.info." + visitorId + ".data.currentChat.metadata.connectorAuthResponse", [metadata[key]], "id");
                                }
                                break;
                            default :
                                break;
                        }
                    }
                }
            }
    }
    return lpMessagesControllerV2;

});
